import { Model } from '@vuex-orm/core'
import Checkout from '@/models/user/Checkout'
import dayjs from '@/plugins/dayjs.plugin'
import AgeGroup from '../AgeGroup'
import { ActionContext } from 'vuex'

export default class HotelSearch extends Model {
  declare id: string
  declare startDate: string
  declare endDate: string
  declare minPrice: number
  declare maxPrice: number
  declare rating: number
  declare searched: boolean
  declare customerDetail: Checkout
  declare promotionCode?: string
  declare propertyId?: number
  declare fullPayment?: number
  declare lang: string

  static entity = 'hotelSearch'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.uid(),
      startDate: this.attr(dayjs().day(6).format('YYYY-MM-DD')),
      endDate: this.attr(dayjs().day(6).add(7, 'day').format('YYYY-MM-DD')),
      // locationName: this.string(''),
      // searchCountryId: this.attr(null),
      // searchRegionId: this.attr(null),
      // searchStateId: this.attr(null),
      minPrice: this.number(-1),
      maxPrice: this.number(-1),
      rating: this.number(-1),
      searched: this.boolean(true),
      customerDetail: this.hasMany(Checkout, 'hotelSearchId'),
      // mapMode: this.boolean(false),
      // filterRange: this.hasMany(FilterRange, 'hotelSearchId'),
      // rekaPropertyTypes: this.hasMany(FilterRekaType, 'hotelSearchId'),
      // propertyTypes: this.hasMany(FilterType, 'hotelSearchId'),
      promotionCode: this.string(null).nullable(),
      propertyId: this.number(null).nullable(),
      fullPayment: this.number(0).nullable(),
      lang: this.string('EN'),
    }
  }

  static get instance() {
    const retrievedInstance = this.query().find(1)
    if (retrievedInstance) return retrievedInstance

    const newInstance = new this()
    newInstance.$save()

    return newInstance
  }

  get startTime() {
    return dayjs(this.startDate).toDate()
  }

  get endTime() {
    return dayjs(this.endDate).toDate()
  }

  get nights() {
    return dayjs(this.endDate).diff(this.startDate, 'day')
  }
}
